import * as React from "react"
import { Link } from "gatsby"
import { formatPrice } from "../utils/format-price"
import Heading from './Heading'
import resolveLink from "src/utils/resolveLink"

export function ProductCard({ product, eager }) {
  const {
    title,
    handle,
    images: [firstImage],
    variants: [initialVariant],
  } = product

  const price = formatPrice(
    initialVariant.price.currencyCode,
    initialVariant.price.amount
  )

  const hasImage = firstImage

  return (
    <Link
      to={resolveLink(`/cx-tools-shop/${handle}`)}
      aria-label={`View ${title} product page`}
      className="group"
    >
      {hasImage
        && (
          <div 
            data-name="product-image-box"
            className="group-hover:opacity-70 duration-300"
          >
            <img
              alt={firstImage?.altText ?? title}
              src={firstImage?.src}
              loading={eager ? "eager" : "lazy"}
            />
          </div>
        )
      }
      <div>
        <Heading size="h4" className="text-darkgrey !leading-none mt-4 group-hover:text-red duration-300 mb-0">{title}</Heading>
        <div className="text-red text-lg font-display">{price}</div>
      </div>
    </Link>
  )
}
